import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';

export const organizationService = {
    fetchBranding,
};

function fetchBranding() {
    return apiClient
        .get(api.organization.getBranding)
        .then(handleResponse)
        .then((response) => response?.data ?? response ?? {})
        .catch((error) => handleError(error.response));
}
